export const RECOVERY_QUESTION_BANK = [
  { id: "moms-brother", label: "Your Mom's Brother's name" },
  { id: "first-pet", label: "Your First Pet's name" },
  { id: "first-school", label: "Your First School's name" },
  { id: "favorite-teacher", label: "Your Favorite Teacher's name" },
  { id: "birth-city", label: "The City You Were Born In" },
];
